import React, { useCallback, useEffect } from 'react';
import { NoPaymentMethodsView } from './view';
import { getBiLogger } from '../../utils/biLogger';
import {
  getPaymentArraysFromMethods,
  logCheckOutNoAvailableProvidersRefreshClicked,
} from './utils';

export interface NoPaymentMethodsControllerProps {
  showingNoPaymentsFirstTime?: boolean;
  paymentMethods?: any[];

  onRefreshClick?(): Promise<any>;
}

export const NoPaymentMethodsController: React.FC<NoPaymentMethodsControllerProps> =
  (props) => {
    const logCheckOutNoAvailableProvidersPopUpShown = () => {
      const { paymentCategory, paymentProvider } = getPaymentArraysFromMethods(
        props.paymentMethods
      );

      getBiLogger().checkOutNoAvailableProvidersPopUpShown({
        paymentCategory: paymentCategory.join(','),
        paymentProvider: paymentProvider.join(','),
      });
    };

    useEffect(() => {
      if (props.showingNoPaymentsFirstTime) {
        logCheckOutNoAvailableProvidersPopUpShown();
      }
    }, []);

    const handleRefreshClick = useCallback(() => {
      const handleClickResult = props.onRefreshClick?.();

      if (handleClickResult) {
        handleClickResult.then(logCheckOutNoAvailableProvidersRefreshClicked);
      }
    }, []);
    const { paymentMethods } = props;
    const isPaymentMethodsConnected = paymentMethods?.length > 0;

    return (
      <NoPaymentMethodsView
        handleRefreshClick={handleRefreshClick}
        isPaymentMethodsConnected={isPaymentMethodsConnected}
      />
    );
  };

NoPaymentMethodsController.displayName = 'NoPaymentMethodsController';
